import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-curtain', 'showLess', 'Show less');
Labels.set('ui-curtain', 'showMore', 'Show more');
Labels.set('ui-curtain', 'completedStep', 'Completed step');
